import { Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import { DeactivateAccountScreenProps } from "./types";

const DeactivateAccountMobile = ({ onCancel, onPressDeactivate }: DeactivateAccountScreenProps) => {
  return (
    <Container Header={<MobileHeader title="Desativar Conta" onBackPress={onCancel} />}>
      <VStack>
        <Text py="4" fontSize="lg" bold>
          Tem certeza que deseja desativar a sua conta?
        </Text>
        <Text fontSize="md">
          Lamentamos muito que você tenha que optar por excluir sua conta. Vale lembrar que após o
          início do processo de exclusão, você não poderá reativar ou recuperar qualquer dados sobre
          a sua conta.
        </Text>
      </VStack>
      <FormButton mt="10" onPress={onPressDeactivate}>
        Desativar Conta
      </FormButton>
      <FormButton
        colorScheme="white"
        textColor="primary.700"
        my="4"
        shadow="2"
        onPress={() => onCancel()}>
        Cancelar
      </FormButton>
    </Container>
  );
};

export default DeactivateAccountMobile;
